// extracted by mini-css-extract-plugin
module.exports = {"grid":"Schemes_grid__GGf8w","item":"Schemes_item__qUkUS"};